<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] transition-all duration-300">
        <div class="h-full bg-white rounded-xl dark:bg-[#102030]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex gap-3 shrink-0 items-center">
                    <img class="ml-[5px] w-8 flex-none" src="/assets/images/logo.png" alt="" />
                    <span class="logo-text align-middle text-2xl font-medium ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">LOS</span>
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <svg class="m-auto h-5 w-5" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            opacity="0.5"
                            d="M16.9998 19L10.9998 12L16.9998 5"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 p-4 py-0 font-normal">

                    <li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Dashboard' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/opportunities" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-user-plus class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Opportunity' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/loan-application" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Loan Application' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/payment-maker" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-credit-card class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Fees Maker' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/payment-checker" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Fees Checker' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/quality-check-cpa" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Quality Check CPA' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/financial-analysis" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Financial Analysis' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/initiation" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-drag-and-drop class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Initiation' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/capturing" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-datatables class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Capturing' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/completion" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-pages class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Completion' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/underwriter" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-forms class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Underwriter' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/post-sanction-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-calendar class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Post Sanction Cases' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/amendatory-sanction-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-components class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Amendatory Sanction' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/quality-check-operations" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Quality Check Operations' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/disbursed-cases" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-dollar-sign-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark"
                                    >{{ 'Disbursed Cases' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <!-- <li class="accordion menu nav-item">
                        <button
                            type="button"
                            class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('project-management') }"
                            (click)="toggleAccordion('project-management')"
                        >
                            <div class="flex items-center">
                                <icon-menu-components class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-gray-400 dark:group-hover:text-white-dark">
                                    {{ 'Project management' | translate }}
                                </span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('project-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('project-management')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/project-details" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Project Details' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/project-documents" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'Project Documents ' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/rera-details" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"  (click)="toggleMobileMenu()">{{ 'RERA Details' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/project-schemes" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Project Schemes' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/work-progress" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Work Progress' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/payment-schedule" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="toggleMobileMenu()">{{ 'Payment Schedule' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li> -->
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
